export function onIonPressEnter(
  event: React.KeyboardEvent<HTMLIonInputElement>,
  callback: () => void
) {
  if (event.key == "Enter") callback();
}

export const rootPath = "/app";
